<template>
  <div v-if="pickUpInfo.show" class="main-container">
    <div class="information-box">
      <div class="column-1">
        <div class="titleContainer">
          <div class="title">
            DETALLE ENTREGA
          </div>
          <div class="closeTab" v-if="showBtn">
            <button class="closeClass" v-on:click="hideComponent()">
              <i class="fa fa-times-circle"/>
            </button>
          </div>
        </div>
        <div class="table">
          <el-table :data="pickUpInfo.list"
                    size="mini"
                    height="150">
            <el-table-column :label="pickUpInfo.labelOne" type="index" align="center">
            </el-table-column>
            <el-table-column prop="labelTwo" :label="pickUpInfo.labelTwo" align="center">
            </el-table-column>
            <el-table-column prop="labelThree" :label="pickUpInfo.labelThree" align="center">
            </el-table-column>
            <el-table-column prop="labelFour" :label="pickUpInfo.labelFour" align="center">
              <template slot-scope="scope">
                <el-tag size="mini"
                        v-if="scope.row.labelFour === 1"
                        :hit="true"
                        style="background-color: #00b0ff; color: #333333;  opacity: 0.8;">
                  DIGITADO
                </el-tag>
                          <el-tag size="mini"
                        v-if="scope.row.labelFour === 2"
                        :hit="true"
                        style="background-color: #00b0ff; color: #333333;  opacity: 0.8;">
                  PLANIFICADO
                </el-tag>
                <el-tag size="mini"
                        v-if="scope.row.labelFour === 5"
                        :hit="true"
                        :type="'sucess'">
                  TERMINADO
                </el-tag>
                <el-tag size="mini"
                        v-if="scope.row.labelFour === 4"
                        :hit="true"
                        :type="'danger'">
                  PENDIENTE
                </el-tag>
                <el-tag size="mini"
                        v-if="scope.row.labelFour === 6"
                        :hit="true"
                        :type="'danger'">
                  CANCELADO
                </el-tag>
                <el-tag size="mini"
                        v-if="scope.row.labelFour === 3"
                        :hit="true"
                        :type="'info'">
                  EN RUTA
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column v-if="pickUpInfo.labelSix !== ''"
                             prop="labelSix" :label="pickUpInfo.labelSix"
                             align="center" width="400">
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  components: {
  },
  props: {
    pickUpInfo: {
      type: Object,
    },
    showBtn: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      show: true,
    };
  },
  methods: {
    hideComponent() {
      this.$emit('updateShow', false);
    },
  },
  computed: {
  },
  watch: {
  },
};
</script>

<style scoped>
  .information-box {
    display: flex;
    flex-direction: row;
    justify-content: normal;
  }
  .column-1 {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    margin-bottom: 3%;
    width: 100%;
  }
  .key-style {
    font-weight: 300;
    font-size: 15px;
    margin-right: 2%;
  }
  .information-style {
    display: flex;
    flex-direction: column;
    width: 30%;
    margin-top: 1.2%;
  }
  .box-info-style {
    display: flex;
    flex-direction: row;
    margin-top: 1%;
  }
  .titleContainer {
    display: flex;
    justify-content: space-between;
    padding-right: 1em;
    padding: 0 0 1em 0;
  }
  .title {
    font-size: 17px;
    text-align: justify;
    color: #9B9B9B;
  }
  .home-boton i {
    font-size: 50px;
    color: #AAD500;
    margin-top: 5%;
    cursor: pointer;
  }
  .table{
    border: 0px solid #F6F6F6;
  }
  .linkStyle{
    color: #AAD500;
    border: none;
    font-weight: 600;
    font-size: 15px;
    outline: none;
    cursor: pointer;
  }
  .closeClass {
    color: #AAD500;
    border: none;
    font-weight: 600;
    font-size: 25px;
    outline: none;
    cursor: pointer;
  }
</style>
